export default {"src":"/_next/static/media/home-profile-tips-purple.15930d43.svg","height":70,"width":71,"blurWidth":0,"blurHeight":0};